import React, { useState } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import uniqBy from 'lodash/uniqBy';

import { OrderHistoryTable } from './OrderHistoryTable';

import { DATE_FORMAT } from 'constants/date-constants';
import { ARCHIVED, READY } from 'constants/states-app';

import { TotemButton } from 'ui/Button';
import { DashboardOrderHistoryProps } from 'pages/Totem/TotemDashboard/TotemDashboard.types';

/**
 * Displays all orders to come and orders delivered today
 */

import { GetReadyPunctualOrdersQuery } from 'data/__generated__';

export interface OrdersScheduleProps
    extends Pick<DashboardOrderHistoryProps, 'ordersOfTotem' | 'baseUrl' | 'defaultCategoryId'> {
    hasValidatedOrders: boolean;
    readyPunctualOrders: GetReadyPunctualOrdersQuery['readyPunctualOrders'] | null;
}
export const OrdersSchedule: React.FC<OrdersScheduleProps> = ({
    baseUrl,
    defaultCategoryId,
    hasValidatedOrders,
    ordersOfTotem,
    readyPunctualOrders = [],
}) => {
    // constants
    const INITIAL_NB_ORDERS_TO_SHOW = 5;

    // state
    const [nbOrderToShow, setNbOrderToShow] = useState(INITIAL_NB_ORDERS_TO_SHOW);

    // orders
    const recentOrders = ordersOfTotem?.recentOrders ?? [];
    const currentOrders = recentOrders?.filter((order) => order?.state !== ARCHIVED);
    const readyOrders = recentOrders?.filter((order) => order?.state === READY);
    const ordersToShow = uniqBy(
        [...currentOrders, ...readyOrders, ...(readyPunctualOrders ?? [])]?.filter((order) => order),
        (order) => order?._id,
    ).sort((a, b) => (dayjs(a?.date_delivery, DATE_FORMAT).isBefore(dayjs(b?.date_delivery, DATE_FORMAT)) ? 1 : -1));

    return (
        <>
            {ordersToShow.length ? (
                <>
                    <OrderHistoryTable
                        ordersToShow={ordersToShow}
                        nbOrderToShow={nbOrderToShow}
                        ordersOfTotem={ordersOfTotem}
                        defaultCategoryId={defaultCategoryId}
                        baseUrl={baseUrl}
                    />
                    {ordersToShow.length > nbOrderToShow && (
                        <TotemButton
                            $alignSelf="center"
                            $fontSize="1em"
                            onClick={() => setNbOrderToShow(nbOrderToShow + 5)}
                        >
                            Voir plus
                        </TotemButton>
                    )}
                </>
            ) : (
                <ScheduleText>
                    {hasValidatedOrders
                        ? "Vous n'avez aucune commande en cours !"
                        : 'Vos commandes apparaîtront ici. Cliquez sur le bouton pour créer votre première commande !'}
                </ScheduleText>
            )}
        </>
    );
};

const ScheduleText = styled.div`
    font-size: 18px;
`;
